import React from 'react'
import './marquee.css'
import { useSidebar } from '../../context/sidebar/SidebarContext'

const Marquee = () => {
  const { isSidebarOpen } = useSidebar()
  return (
    <div className={`marquee-layout ${!isSidebarOpen ? 'full-width' : ''}`}>
      <div className="marquee-container">
        <div className="marquee-content">
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
          <span>Testing System</span>
        </div>
      </div>
    </div>
  )
}

export default Marquee
